import { Box, MenuItem, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

import { Enderecaveis } from "./types";

export type Visao = { tipo: "declarados" } | { tipo: "enderecaveis"; workspaceId: string };

export function SeletorPerspectiva({ enderecaveis, visao, onChange }: {
  enderecaveis: Enderecaveis[]; visao: Visao; onChange: (v: Visao) => void;
}) {
  if (enderecaveis.length === 0) return null;
  const ws = visao.tipo === "enderecaveis" ? visao.workspaceId : "";
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box display="flex" flexWrap="wrap" alignItems="center" gap={2}>
        <ToggleButtonGroup
          exclusive
          size="small"
          aria-label="Perspectiva"
          data-testid="perspectiva"
          value={visao.tipo}
          onChange={(_, v) => {
            if (v === "declarados") onChange({ tipo: "declarados" });
            else if (v === "enderecaveis") onChange({ tipo: "enderecaveis", workspaceId: enderecaveis[0].workspaceId });
          }}
        >
          <ToggleButton value="declarados">Todos os declarados</ToggleButton>
          <ToggleButton value="enderecaveis">Endereçáveis no plano</ToggleButton>
        </ToggleButtonGroup>
        {visao.tipo === "enderecaveis" && enderecaveis.length > 1 && (
          <TextField
            select
            size="small"
            label="Contrato"
            data-testid="perspectiva-contrato"
            value={ws}
            onChange={(e) => onChange({ tipo: "enderecaveis", workspaceId: e.target.value })}
            sx={{ minWidth: 220 }}
          >
            {enderecaveis.map((c) => (
              <MenuItem key={c.workspaceId} value={c.workspaceId}>
                {c.nome}
              </MenuItem>
            ))}
          </TextField>
        )}
      </Box>
      {visao.tipo === "enderecaveis" && (
        <Typography variant="body2" color="text.secondary" data-testid="perspectiva-nota">
          Endereçável é quem o contrato aceita, não quem já está incluído.
        </Typography>
      )}
    </Box>
  );
}
